import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'jft-revision-currencies-conversion',
    templateUrl: './revision-currencies-conversion.component.html',
    styleUrls: ['./revision-currencies-conversion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevisionCurrenciesConversionComponent implements OnInit {
    @Input() public currencies;
    @Input() public conversionFactor;
    @Input() public tender;
    @Input() public baseCurrency;
    @Output() onUpdateExchangeRates = new EventEmitter();
    @Output() onSetCustomCurrency = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }
    
    public updateExchangeRates(event){
        this.onUpdateExchangeRates.emit(event);
    }
    
    public onCustomCurrency(event){
        this.onSetCustomCurrency.emit(event);
    }
}
